module.exports = __webpack_public_path__ + "static/media/arrow-down.814f4897.svg";